import { LITE_TRADE_POSITION_SIDE } from '../liteTradeConstants';
import { ILiteTradeAssetSymbol, ILiteTradePortfolioPosition } from '../types/liteTradeReducer.t';

function calcAssetFilledQuantity(symbol: ILiteTradeAssetSymbol, positions?: ILiteTradePortfolioPosition[]) {
    const result = {
        [LITE_TRADE_POSITION_SIDE.BUY]: 0,
        [LITE_TRADE_POSITION_SIDE.SELL]: 0,
    };
    positions?.forEach(item => {
        if (item.symbol === symbol) {
            result[item.side] += item.quantity;
        }
    });
    return result;
}

export default calcAssetFilledQuantity;
